import { InstallSpec } from "@p0security/shared/install/types";

export const GcpSmComponents = InstallSpec({
  "iam-write": {
    type: "dynamic",
    label: "Vault",
    description: "Allow P0 to vault credentials",
    maturity: "preview",
    schema: {},
  },
});
